import { RoutesService, eLayoutType } from '@abp/ng.core';
import { inject, provideAppInitializer } from '@angular/core';

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];

function configureRoutes() {
  const routes = inject(RoutesService);
  routes.add([
      {
        path: '/',
        name: '::Menu:Home',
        iconClass: 'fas fa-home',
        order: 1,
        layout: eLayoutType.application,
      },
      {
        path: '/dashboard',
        name: '::Menu:Dashboard',
        iconClass: 'fas fa-chart-line',
        order: 2,
        layout: eLayoutType.application,
        requiredPolicy: 'UseIt.Dashboard.Host  || UseIt.Dashboard.Tenant',
      },
      {
        path: '/admin/training-review',
        name: '::Menu:AdminTrainingReview',
        iconClass: 'fas fa-robot',
        order: 3,
        layout: eLayoutType.application,
        requiredPolicy: 'UseIt.Admin.TrainingReview',
      },
      {
        path: '/admin/minddex',
        name: '::Menu:AdminMindDex',
        iconClass: 'fas fa-book-open',
        order: 4,
        layout: eLayoutType.application,
        requiredPolicy: 'UseIt.Admin.MindDex',
      },
      {
        path: '/admin/client-release',
        name: '::Menu:AdminRelease',
        iconClass: 'fas fa-mobile-alt',
        order: 5,
        layout: eLayoutType.application,
        requiredPolicy: 'UseIt.Admin.Release',
      },
      {
        path: '/admin/feature-access',
        name: '::Menu:AdminFeatureAccess',
        iconClass: 'fas fa-key',
        order: 6,
        layout: eLayoutType.application,
        requiredPolicy: 'UseIt.Admin.FeatureAccess',
      },
  ]);
}
